var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJerryHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29390",
    "data-name": "Group 29390",
    transform: "translate(-8 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-jerry",
    transform: "translate(25 352.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50108",
    "data-name": "Path 50108",
    d: "M29.9,7.631C27.949,5.682,26,12.5,26,12.5l5.36.975S32.091,9.824,29.9,7.631Z",
    transform: "translate(-15.317 -7.281)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50109",
    "data-name": "Path 50109",
    d: "M13.946,11.924c1.462-.975,5.36-1.462,5.36-1.462s-4.161.131-4.873.487A3.4,3.4,0,0,0,15.408,9s-1.462,2.436-3.9,2.436c0,0-3.655-4.142-6.335-1.462C3.47,11.68,4.2,20.207,10.878,21.883c.566.142,1.543,2.057,4.114,2.571,1.939.388,11.272-1.418,7.293-4.807a1,1,0,0,1-.291-1.068,5.339,5.339,0,0,0,.235-3.245c-.289-.993-.487-1.949-2.924-2.924C17.945,11.866,13.946,11.924,13.946,11.924Z",
    transform: "translate(-4.238 -8.163)",
    fill: "#fb8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50110",
    "data-name": "Path 50110",
    d: "M7.937,17.025s1.462,1.949,2.436,0c1.239-2.477-3.3-6.9-5.36-5.36s-.975,10.233,5.7,11.422c0,0-1.886-3.057-.343-4.6C10.373,18.486,8.965,19.6,7.937,17.025Z",
    transform: "translate(-4.075 -9.365)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50111",
    "data-name": "Path 50111",
    d: "M27.389,25.565s-3.457-5.618-.864-5.365a1.845,1.845,0,0,1,1.356.865,5.156,5.156,0,0,1,.536,4.5H27.389Z",
    transform: "translate(-15.091 -13.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50112",
    "data-name": "Path 50112",
    d: "M36.142,26.192s-1.484-5.768.514-4.629c1.094.624.515,4.629.515,4.629Z",
    transform: "translate(-20.245 -14.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50113",
    "data-name": "Path 50113",
    d: "M30.584,27.589c0-.878-.285-1.589-.636-1.589s-.636.711-.636,1.589a3.349,3.349,0,0,0,.13.954h1.012A3.354,3.354,0,0,0,30.584,27.589Z",
    transform: "translate(-17.015 -16.879)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50114",
    "data-name": "Path 50114",
    d: "M36.773,27.13c0-.71-.23-1.285-.514-1.285-.169,0-.314.212-.407.527.156,1.069.407,2.044.407,2.044C36.543,28.416,36.773,27.84,36.773,27.13Z",
    transform: "translate(-20.368 -16.799)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50115",
    "data-name": "Path 50115",
    d: "M25.551,31.038a3.779,3.779,0,0,1,3.085.514s1.543-1.543,2.571,0c0,0,.514,1.029-1.029,1.543,0,0,.254,1.681-2.317,2.709,0,0-.731,2.68-3.411,0a6.855,6.855,0,0,1-1.472-3.223S27.094,33.61,25.551,31.038Z",
    transform: "translate(-13.768 -19.374)",
    fill: "#ffe082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50116",
    "data-name": "Path 50116",
    d: "M30.873,34.972c-.4.146-.687-.273-.687-.273a2.293,2.293,0,0,1-3.081-.508c-.143.083-.908-.223-1.1-.194l.487,1.462c.975,2.924,2.155,1.811,2.155,1.811C29.7,35.858,29.9,35.46,30.873,34.972Z",
    transform: "translate(-15.317 -20.979)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50117",
    "data-name": "Path 50117",
    d: "M27.769,37.148A.59.59,0,0,0,27,36.933c.975,3.9,2.436,1.462,2.436,1.462A1.6,1.6,0,0,0,27.769,37.148Z",
    transform: "translate(-15.829 -22.452)",
    fill: "#ff5252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50118",
    "data-name": "Path 50118",
    d: "M33.4,31.733l.744.744a.485.485,0,0,0,.632.049c.578-.432,1.462-1.307-.861-1.307C32.885,31.219,33.4,31.733,33.4,31.733Z",
    transform: "translate(-19.044 -19.555)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50119",
    "data-name": "Path 50119",
    d: "M23.385,29s2.924,3.9-1.949,2.924L19,31.436Z",
    transform: "translate(-11.728 -18.417)",
    fill: "#fb8c00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 0.487,
    cy: 0.163,
    rx: 0.487,
    ry: 0.163,
    transform: "translate(14.638 11.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50120",
    "data-name": "Path 50120",
    d: "M36,18.38a1.787,1.787,0,0,1,.828-.248,2.91,2.91,0,0,1,.794.061,3.554,3.554,0,0,0-.462-.4,2.781,2.781,0,0,0-.383.1A1.9,1.9,0,0,0,36,18.38Z",
    transform: "translate(-20.444 -12.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50121",
    "data-name": "Path 50121",
    d: "M23.495,19.338a2.347,2.347,0,0,1,.246-1.194,1.5,1.5,0,0,1,1-.831A1.873,1.873,0,0,1,26,17.564a5.224,5.224,0,0,1,.493.363c.145.142.286.285.415.437-.185-.084-.358-.177-.527-.271s-.354-.152-.521-.236a1.968,1.968,0,0,0-1.024-.127,1.411,1.411,0,0,0-.792.6A5.56,5.56,0,0,0,23.495,19.338Z",
    transform: "translate(-14.03 -12.41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJerryHighlighted);
export default __webpack_public_path__ + "static/media/jerryHighlighted.94b6fdbd783bdbe61e52733d233cc599.svg";
export { ForwardRef as ReactComponent };